export default __webpack_public_path__ + "static/media/k_p_img3.c6c770f2.JPG";